import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/npajwKv1oXdLAkC43kzxRp/image27.jpg',
  alt: 'Blonde highlights transformation'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vAgj6tGZbmFXcxWS5Bgsti/image22.jpg',
  alt: 'Red copper curls styling'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gRpiSgT7PpXKszjQ3GRzaf/image26.jpg',
  alt: 'Sleek dark hair treatment'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eWoXLKa33wRW6H1p2P6XS1/image14.jpg',
  alt: 'Copper red straight extensions'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oh4V3GwJHutLxVtWGwKy2i/image24.jpg',
  alt: 'Blonde balayage styling'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a491pUQx7Svq6naKg1ow3x/image19.jpg',
  alt: 'Pink peekaboo color'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uB6vk5UasS2TcX2h7fMuEg/image23.jpg',
  alt: 'Blonde straight hair'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d5wkNRYjJW6n96AFY4xvzs/image0_(1).jpg',
  alt: 'Blonde layered blowout'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8g73uy6DEt2waJYvteBrAc/image1_(1).jpg',
  alt: 'Short blonde bob with highlights'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jXATNJm4JexsfHHVWGVaDj/image4_(1).jpg',
  alt: 'Curly blonde styling'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7DpdBTLSuoKLQMzNSKsSkj/image5.jpg',
  alt: 'Brunette balayage long hair'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bXaHt86brmbNQHJhxJiSA1/image7.jpg',
  alt: 'Sleek brunette straight hair'
}];
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-studio-black relative" data-id="element-50">
      <div className="max-w-6xl mx-auto px-4" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-52">
          <h2 className="text-3xl md:text-5xl font-playfair text-white mb-4" data-id="element-53">
            {t('gallery.title')}
          </h2>
          <div className="w-24 h-[1px] bg-studio-gold mx-auto mb-6" data-id="element-54"></div>
          <p className="text-gray-400 font-inter font-light max-w-xl mx-auto" data-id="element-55">
            {t('gallery.subtitle')}
          </p>
        </motion.div>

        <div className="columns-2 md:columns-3 gap-4 space-y-4" data-id="element-56">
          {galleryImages.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative overflow-hidden group break-inside-avoid" data-id="element-57">
              <img src={image.src} alt={image.alt} className="w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-58" />
              <div className="absolute inset-0 bg-studio-gold/0 group-hover:bg-studio-gold/10 transition-colors duration-500 pointer-events-none" data-id="element-59"></div>
              <div className="absolute inset-0 border border-studio-gold/0 group-hover:border-studio-gold/20 m-3 transition-all duration-500 pointer-events-none" data-id="element-60"></div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}